module.exports = __webpack_public_path__ + "media/images/tl/banner/en-2-light-ddb1d65f0f1b95e652e5a96882b5a274.jpg";